import { PeopleDepartmentDto } from '../people-department.dto';
import { PeopleJobTitleDto } from '../people-job-title.dto';
import { PeopleEmployeeDto } from './people-employee.dto';

export class PeopleEmployeeWorkProfileDto {
    id?: number;
    employeeId?: number;
    departmentId?: number;
    jobTitleId?: number;
    workEmail?: string;
    workPhoneNumber?: string;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

    employee?: PeopleEmployeeDto;
    department?: PeopleDepartmentDto;
    jobTitle?: PeopleJobTitleDto;
}